import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Input, AutoComplete } from ".";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#fff",
  },
  container: {
    display: "grid",
    gridTemplateColumns: "180px 180px auto 140px 140px 140px 40px",
    alignItems: "center",
    columnGap: 16,
    padding: 4,
    minHeight: 40,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  buttonContainer: {
    padding: 4,
  },
}));

export default function TransferItems({
  push,
  remove,
  form,
  products = [],
  warehouses = [],
  fromKey,
  toKey,
}) {
  const items = form.values?.items ?? [];

  const classes = useStyles();

  const getValue = (item, key) => {
    const product = products.find((t) => t._id === item.product);
    return _.get(product, key);
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="button" className={classes.center}>
          Warehouse
        </Typography>
        <Typography variant="button" className={classes.center}>
          Product Code
        </Typography>
        <Typography variant="button">Description</Typography>
        <Typography variant="button" className={classes.center}>
          From Stock
        </Typography>
        <Typography variant="button" className={classes.center}>
          To Stock
        </Typography>
        <Typography variant="button" className={classes.center}>
          Transfer Qty
        </Typography>
      </div>

      <Divider />

      {items?.map((item, index) => (
        <React.Fragment key={index}>
          <div className={classes.container}>
            <AutoComplete
              name={`items[${index}].warehouse`}
              options={warehouses}
              bottom={0}
            />

            <AutoComplete
              name={`items[${index}].product`}
              options={products}
              bottom={0}
            />

            <Typography>{getValue(item, "description")}</Typography>

            <Typography className={classes.center}>
              {getValue(item, fromKey) ?? 0}
            </Typography>

            <Typography className={classes.center}>
              {getValue(item, toKey) ?? 0}
            </Typography>

            <Input
              name={`items[${index}].quantity`}
              type="number"
              bottom={0}
              inputProps={{ style: { textAlign: "center" } }}
            />

            <IconButton
              color="inherit"
              edge="start"
              onClick={() => remove(index)}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </div>

          <Divider />
        </React.Fragment>
      ))}

      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          onClick={() => push({ quantity: 0 })}
          startIcon={<AddIcon />}
        >
          Add Lines
        </Button>
      </div>
    </div>
  );
}
